import { render } from "./BuyerData.vue?vue&type=template&id=1764f199"
import script from "./BuyerData.vue?vue&type=script&lang=js"
export * from "./BuyerData.vue?vue&type=script&lang=js"

import "./BuyerData.vue?vue&type=style&index=0&id=1764f199&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__